import "core-js/stable";
import './helpers/polyfills';

// external libraries
import '../styles/style.scss';
import '../images/custom-icons.svg';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import JobsList
	from "./fusion/JobsList";
import ContactForms from "./fusion/Root";
import CustomSelect from './component/_custom-select';
import LocationSelect from './component/_location-select';
import FloatingButton from "./fusion/FloatingButton";
import HashMenu from './fusion/HashMenu';
import PageSelect from './fusion/PageSelect'
import PressNewsOverviewPage from './fusion/PressNewsOverviewPage';
import ScrollTop from './fusion/ScrollTop';
import HeroSlider from './component/_hero-slider';
import HeroImage from './component/_hero-image';
import HeroText from './component/_hero-text';
import TeaserSlider from './component/_teaser-slider';
import AwardsSlider from './component/_awards-slider';
import Header from "./fusion/Header";
import Accordion from "./component/_accordion";
import Gallery from "./component/_gallery";
import Video from "./component/_video";
import ScrollLinksHandler from "./component/_scroll-links.js";
import SwitchLanguageNotice from "./component/_switch-language-notice.js";
import Modal from "./component/_modal.js";
import Table from "./component/_table.js";
import PressDetailsContent from "./component/_press-details-content.js";
import Breadcrumbs from "./component/_breadcrumbs";
import QuickLinks from "./component/_quick-links";
import SectionCollapsible from "./component/_section-collapsible";
import Tooltip from "./component/_tooltip";
import Preloader from "./helpers/preloader";
import TooltipSlider from "./component/_tooltip-slider";
import Forms from "./component/_forms";
import CardList from "./component/_card-list";
import AnalyticsEvent from "./fusion/AnalyticsEvent";
import Tabs from "../../../../Private/Fusion/Presentation/Molecule/Tabs/Tabs";
import SocialMediaWall from "./component/_social-media-wall";
import EqsForm from "./component/_eqs-form";
import Map from "../../../../../NodeTypes/Content/Map/Map";
import InteractiveMapWithAccordion from "../../../../../NodeTypes/Content/InteractiveMapWithAccordion/InteractiveMapWithAccordion.Backend";
import Timeline from "./component/_timeline";

// init application
class App {
	constructor() {
		Forms.init();
		QuickLinks.init();
		CustomSelect.init();
		LocationSelect.init();
		PageSelect.init();
		PressNewsOverviewPage.init();
		Header.init();
        FloatingButton.init();
		HashMenu.init();
		HeroImage.init();
		HeroText.init();
        AnalyticsEvent.init();
		HeroSlider.init();
		TeaserSlider.init();
		AwardsSlider.init();
		Accordion.init();
		Gallery.init();
		Video.init();
		JobsList.init();
		ScrollLinksHandler.init();
		ScrollTop.init();
		SwitchLanguageNotice.init();
		Modal.init();
		Table.init();
		PressDetailsContent.init();
		Breadcrumbs.init();
		ContactForms.init();
		SectionCollapsible.init();
		Tooltip.init();
		Preloader.init();
		TooltipSlider.init();
		CardList.init();
        Tabs.init();
        SocialMediaWall.init();
        EqsForm.init();
        Map.init();
        InteractiveMapWithAccordion.init();
        Timeline.init();

		// lazy load lottie player
		if(document.querySelectorAll('lottie-player').length) {
			this.lazyLoad('/_Resources/Static/Packages/CodeQ.Site/Frontend/build/scripts/lottie-player.js');
		}

        // fallback, if the Neos cache didn't update correctly and youtube is needed, but not yet loaded
        if (document.querySelectorAll('.youtube-player').length && !document.querySelectorAll('script[src*="youtube-player.js"]')) {
            this.lazyLoad('/_Resources/Static/Packages/CodeQ.Site/Frontend/build/scripts/youtube-player.js');
        }
        if (document.querySelectorAll('.vimeo-player').length && !document.querySelectorAll('script[src*="vimeo-player.js"]')) {
            this.lazyLoad('/_Resources/Static/Packages/CodeQ.Site/Frontend/build/scripts/vimeo-player.js');
        }
        if ((document.querySelectorAll('.imwa').length || document.querySelectorAll('.filtered-download-list').length) && !document.querySelectorAll('script[src*="alpine-components.js"]')) {
            this.lazyLoad('/_Resources/Static/Packages/CodeQ.Site/Frontend/build/scripts/alpine-components.js');
        }
	}

	get() {
		return this;
	}

	lazyLoad(url) {
		(function(w,d,s){
			let f=d.getElementsByTagName(s)[0],
			j=d.createElement(s);
			j.async=true;
			j.src=url;
			f.parentNode.insertBefore(j,f);
		})(window,document,'script');
	}
}

window.app = new App();
